import {Tab} from 'bootstrap';

export default function navTabs() {
    if (!$('.nav-tabs').length) {
        return;
    }

    const hash = window.location.hash;
    // always show the first tab if no hash is set
    const tabSelector = hash ? `[href="${hash}"]` : ':first-child';
    const tab = new Tab(document.querySelector(`.nav-tabs a${tabSelector}`));
    tab.show();

    // keep track of the hash in the url when a nav tab is shown
    // this is done just for control panel nav tabs, since cockpit nav tabs are differently handled in the cockpit/router.ts
    $("#control-panel-tab > li > a").on('show.bs.tab', function (e) {
        history.pushState(undefined, undefined, $(e.target).attr('href'));
    });

    responsiveNavTabs();
}

// enable responsive nav tabs
function responsiveNavTabs(): void {
    $.fn.extend({
        responsiveTabs: function (this: JQuery) {
            this.addClass('responsive-tabs');
            this.append($('<i class="fas fa-chevron-down"></i>'));
            this.append($('<i class="fas fa-chevron-up"></i>'));

            this.on('click', '.nav-link.active, i.fas', function (this: JQuery) {
                this.toggleClass('open');
            }.bind(this));

            this.on('click', '.nav-link:not(.active) > a', function (this: JQuery) {
                this.removeClass('open');
            }.bind(this));
        }
    });

    (<any>$('.nav.nav-tabs')).responsiveTabs();
}